import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable()
export class SettingsService {
    constructor(private api: ApiService) { }

    getSettings() { 
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.settings + '/getSettings')
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/settings.service.ts